import React, { useEffect, useMemo } from "react";

import { useNotification } from "Containers/Notifications";
import * as Sticker from "ds/Sticker";
import { isJson } from "Libs/utils";

type Props = {
  error: unknown;
  notify?: boolean;
};

export const ErrorWithMessage = (props: Props) => {
  const notify = useNotification();

  const message = useMemo(() => {
    if (!props.error) return null;
    let error = props.error;

    if (typeof error === "string" && isJson(error)) error = JSON.parse(error);
    if (typeof error === "string") return error;

    if (
      typeof error === "object" &&
      ("title" in error || "message" in error || "detail" in error)
    ) {
      let msg = "";

      if ("title" in error) msg = `${msg}${error.title as string}: `;
      if ("detail" in error) msg = `${msg}${error.detail as string}`;
      if ("message" in error) msg = `${msg}${error.message as string}`;

      return msg;
    }

    return null;
  }, [props.error]);

  useEffect(() => {
    if (message && props.notify) notify.error(message);
  }, [notify, message, props.notify]);

  if (message === null || props.notify) return null;

  return (
    <Sticker.Root priority="critical">
      <Sticker.Text>{message}</Sticker.Text>
    </Sticker.Root>
  );
};
